import * as React from "react";
import Row from "../../../../layout/Row";
import Col from "../../../../layout/Col";
import FormButtonsView from "../../../../ui/form/FormButtonsView";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import {FormGroupProps} from "../../../../common/props/FormGroupProps";
import Address from "../../../../../model/address/Address";
import {FocusableProps} from "../../../../common/props/FocusableProps";
import FormGroup from "../../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import Input from "../../../../../hiberUiKit/src/atoms/Input/Input";
import Modal from "../../../../ui/modal/Modal";
import {none, option, Option} from "ts-option";

interface ComponentProps {
	/**
	 * Close modal
	 */
	closeModal: () => void;
}

interface IState {
	buildingName: Option<string>;
	subBuilding: Option<string>;
	buildingNumber: Option<string>;
	street: Option<string>;
	city: Option<string>;
	postcode: string;
	country: Option<string>;
}

type Props = FormGroupProps<Address> & FocusableProps & ComponentProps;

export default class ManualAddressInputModal extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		props.field.value.map(a => {
			this.state = {
				buildingName: a.buildingName,
				subBuilding: a.subBuilding,
				buildingNumber: a.buildingNumber,
				street: a.street,
				city: a.city,
				// Addresses picked from Google Places may come without a postcode
				postcode: a.postcode || "",
				country: option("Ireland")
			};
		}).getOrElse(() => {
			this.state = {
				buildingName: none,
				subBuilding: none,
				buildingNumber: none,
				street: none,
				city: none,
				postcode: "",
				country: option("Ireland")
			}
		});
		this.onDone = this.onDone.bind(this);
		this.setGivenState = this.setGivenState.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.closeModal} title={this.props.label}>
				<Row>
					<Col xl={12} md={12}>
						<Row>
							<Col xl={12} md={12}>
								<FormGroup label={"Building name"}>
									<Input type={"text"}
										   value={this.state.buildingName.getOrElse("")}
										   onChange={evt => this.setGivenState("buildingName", (evt))}/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col xl={6} md={6}>
								<FormGroup label={"Flat name"}>
									<Input type={"text"}
										   value={this.state.subBuilding.getOrElse("")}
										   onChange={evt => this.setGivenState("subBuilding", (evt))}/>
								</FormGroup>
							</Col>
							<Col xl={6} md={6}>
								<FormGroup label={"Building number"}>
									<Input type={"text"}
										   value={this.state.buildingNumber.getOrElse("")}
										   onChange={evt => this.setGivenState("buildingNumber", (evt))}/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col xl={12} md={12}>
								<FormGroup label={"Street name"}>
									<Input type={"text"}
										   value={this.state.street.getOrElse("")}
										   onChange={evt => this.setGivenState("street", (evt))}/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col xl={6} md={6}>
								<FormGroup label={"City/Town"}>
									<Input type={"text"}
										   value={this.state.city.getOrElse("")}
										   onChange={evt => this.setGivenState("city", (evt))}/>
								</FormGroup>
							</Col>
							<Col xl={6} md={6}>
								<FormGroup label={"Post code"}>
									<Input type={"text"}
										   value={this.state.postcode}
										   onChange={evt => this.setState(
											   {postcode: evt.target.value.trim().length > 0 ? evt.target.value : ""})}/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col xl={12} md={12}>
								<FormGroup label={"Country"}>
									<Input type={"text"}
										   value={this.state.country.getOrElse("")}
										   disabled={true}/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col xl={12} md={12}>
								<FormButtonsView align={"right"}>
									<div className="pull-left">
										<ButtonTertiary label={"Cancel"}
														onClick={this.props.closeModal}/>
									</div>
									<ButtonPrimary label={"Done"}
												   onClick={this.onDone}
												   disabled={this.shouldButtonBeDisabled()}/>
								</FormButtonsView>
							</Col>
						</Row>
					</Col>
				</Row>
			</Modal>
		);
	}

	setGivenState(stateMemberName: any, event: React.ChangeEvent<HTMLInputElement>) {
		const value = event.target.value;
		this.setState({[stateMemberName]: value.trim().length > 0 ? option(value) : none})
	}

	onDone() {
		const manuallyInputedAddress = option(
			Address.fromManualInput(this.state.buildingName, this.state.subBuilding, this.state.buildingNumber, this.state.street,
				this.state.city, this.state.postcode));
		this.props.onChange(this.props.field.updateValue(manuallyInputedAddress));
		this.props.closeModal();
	}

	/**
	 * Should done button be disabled
	 */
	shouldButtonBeDisabled() {
		return this.state.city.isEmpty
	}
}
